import React, { useState, useEffect, useRef } from 'react';
import '../../scss/search_section.scss';
import { useLocation } from "react-router-dom";
import ListDownload from '../popups/ListDownload';
import search from '../../images/common/search.png';
import filter from '../../images/common/filter.png';
import share from '../../images/common/share.png';
import create from '../../images/common/add.png';
import importIcon from '../../images/common/import.png';
import email from '../../images/common/email.png';
import emailColor from '../../images/common/email-color.png';
import print from '../../images/common/print.png';
import printColor from '../../images/common/print-color.png';
import download from '../../images/common/download.png';
import downloadColor from '../../images/common/download-color.png';
import { CSVLink } from "react-csv";
import { useSelector } from 'react-redux';

function ClickOutside(ref, setShowShare) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
            setShowShare(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
}

function SearchSection({ values, handleFilter, callSearchApi, navigateTo, setDownloadtype, downloadtype,
     downloadarray, headers, filename, pageType, openImportPopup, downloadDate, setDownloadDate }) {
    const sharewrapperRef = useRef(null);
    const location = useLocation();
    const [showShare, setShowShare] = useState(false);
    ClickOutside(sharewrapperRef, setShowShare);
    const [printupdate, setPrint] = useState(false);
    const [emailupdate, setEmail] = useState(false);
    const [downloadupdate, setDownload] = useState(false);
    const [searchData, setSearchData] = useState("");
    const [fileName, setFileName] = useState("");
    const userRole = useSelector((state) => state.role);

    const [showdownload, setShowDownload] = useState(false);
    function handleShowDownload () {
        setShowShare(false);
        setDownload(false);
        setShowDownload(true);
    }
    const handleHideDownload = () => {
        setShowDownload(false)
        setDownloadDate({
            from: null,
            to: null
        })
    };

    function Download() {
        setShowShare(false);
        setDownload(false);
    }
    
    var link = encodeURIComponent(window.location.href);
    
    function Email() {
        setShowShare(false);
        setEmail(false);
    }

    function Print(id, title) {
        setShowShare(false);
        setPrint(false);
        if(document.getElementById(id)) {
            var printContent = document.getElementById(id);
        }
        
        if(document.getElementsByClassName('sort-arrows')) {
            var sort = document.getElementsByClassName('sort-arrows');
            for (var i = 0; i < sort.length; i++) {
                sort[i].style.display = 'none';
            }
        }

        if(document.getElementsByClassName('action-heading')[0]) {
            document.getElementsByClassName('action-heading')[0].style.display = 'none';
        }

        if(document.getElementsByClassName('action')) {
            var trashedit = document.getElementsByClassName('action');
            for(var i=0; i < trashedit.length; i++) {
                document.getElementsByClassName('action')[i].style.display = 'none';
            }
        }
        if(document.getElementsByClassName('logo')) {
            var businessLogo = document.getElementsByClassName('logo');
            for(var i=0; i < businessLogo.length; i++) {
                document.getElementsByClassName('logo')[i].style.display = 'none';
            }
        }
        if(document.getElementsByClassName('logo-header')) {
            var businessLogoHeader = document.getElementsByClassName('logo-header');
            for(var i=0; i < businessLogoHeader.length; i++) {
                document.getElementsByClassName('logo-header')[i].style.display = 'none';
            }
        }
        if(document.getElementsByClassName('dns-heading')) {
            var dnsHeader = document.getElementsByClassName('dns-heading');
            for(var i=0; i < dnsHeader.length; i++) {
                document.getElementsByClassName('dns-heading')[i].style.display = 'none';
            }
        }
        if(document.getElementsByClassName('dns-configuration')) {
            var dnsBody = document.getElementsByClassName('dns-configuration');
            for(var i=0; i < dnsBody.length; i++) {
                document.getElementsByClassName('dns-configuration')[i].style.display = 'none';
            }
        }
        if(document.getElementsByClassName(' website-action-heading')) {
            var websiteactionheading = document.getElementsByClassName(' website-action-heading');
            for(var i=0; i < websiteactionheading.length; i++) {
                document.getElementsByClassName(' website-action-heading')[i].style.display = 'none';
            }
        }
        if(document.getElementsByClassName('website-action')) {
            var websiteaction = document.getElementsByClassName('website-action');
            for(var i=0; i < websiteaction.length; i++) {
                document.getElementsByClassName('website-action')[i].style.display = 'none';
            }
        }

        var WinPrint = window.open('', '_blank', `width=${window.outerWidth},height=${window.outerHeight},'noreferrer'`);
        WinPrint.document.write(`
            <html>
                <head>
                    <title>${title}</title>
                </head>
                <body>
                    <h2 style='text-align: center'>${title}</h2>
                    ${printContent.innerHTML}
                </body>
            </html>
        `);
        WinPrint.document.close();
        WinPrint.focus();
        WinPrint.print();
        WinPrint.close();
        if(document.getElementsByClassName('sort-arrows')) {
            var sort = document.getElementsByClassName('sort-arrows');
            for (var i = 0; i < sort.length; i++) {
                sort[i].style.display = 'block';
            }
        }
        if(document.getElementsByClassName('action-heading')[0]) {
            document.getElementsByClassName('action-heading')[0].style.display = 'table-cell';
        }
        if(document.getElementsByClassName('action')) {
            var trashedit = document.getElementsByClassName('action');
            for(var i=0; i < trashedit.length; i++) {
                document.getElementsByClassName('action')[i].style.display = 'table-cell';
            }
        }
        if(document.getElementsByClassName('logo')) {
            var businessLogo = document.getElementsByClassName('logo');
            for(var i=0; i < businessLogo.length; i++) {
                document.getElementsByClassName('logo')[i].style.display = 'flex';
            }
        }
        if(document.getElementsByClassName('logo-header')) {
            var businessLogoHeader = document.getElementsByClassName('logo-header');
            for(var i=0; i < businessLogoHeader.length; i++) {
                document.getElementsByClassName('logo-header')[i].style.display = 'table-cell';
            }
        }
        if(document.getElementsByClassName('dns-heading')) {
            var dnsHeader = document.getElementsByClassName('dns-heading');
            for(var i=0; i < dnsHeader.length; i++) {
                document.getElementsByClassName('dns-heading')[i].style.display = 'table-cell';
            }
        }
        if(document.getElementsByClassName('dns-configuration')) {
            var dnsBody = document.getElementsByClassName('dns-configuration');
            for(var i=0; i < dnsBody.length; i++) {
                document.getElementsByClassName('dns-configuration')[i].style.display = 'flex';
            }
        }
        if(document.getElementsByClassName(' website-action-heading')) {
            var websiteactionheading = document.getElementsByClassName(' website-action-heading');
            for(var i=0; i < websiteactionheading.length; i++) {
                document.getElementsByClassName(' website-action-heading')[i].style.display = 'flex';
            }
        }
        if(document.getElementsByClassName('website-action')) {
            var websiteaction = document.getElementsByClassName('website-action');
            for(var i=0; i < websiteaction.length; i++) {
                document.getElementsByClassName('website-action')[i].style.display = 'flex';
            }
        }
    }

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setSearchData(params.has('search') ? params.get('search') : '');
        setFileName(filename)

        var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
        if(isSafari) {
            setFileName(filename+".csv");
        }
    }, [])

    useEffect(() => {
        if (showShare) {
            document.getElementById('print-content').onmouseover = function () {
                setPrint(true);
            }
            document.getElementById('print-content').onmouseout = function () {
                setPrint(false);
            }
            document.getElementById('download-content').onmouseover = function () {
                setDownload(true);
            }
            document.getElementById('download-content').onmouseout = function () {
                setDownload(false);
            }
            document.getElementById('email-content').onmouseover = function () {
                setEmail(true);
            }
            document.getElementById('email-content').onmouseout = function () {
                setEmail(false);
            }
        }
    }, [showShare])

    const handleShare = () => {
        setShowShare(!showShare);
    }

    const handleEnterkey = (key) => {
        if (key == 'Enter') {
            callSearchApi(searchData);
        }
    }

    const handleSearchData = (query) => {
        setSearchData(query);
        if(query == '') {
            callSearchApi(query);
        }
    }
    return (
        <>
            <div className='seach-section-container'>
                <div className='search-container'>
                    <input type="text" value={searchData} placeholder={values.placeholder} onChange={(e) => handleSearchData(e.target.value)}
                        onKeyDown={(e) => handleEnterkey(e.key)}></input>
                    <img src={search} alt="serachicon" onClick={() => callSearchApi(searchData)}></img>
                </div>
                {values.isFilter && <img className="filter" src={filter} alt="filter" onClick={() => handleFilter("", "")}></img>}
                <img className='share' src={share} alt="share" onClick={handleShare}></img>
                {values.isCreate && (pageType == "Roles" || pageType == "Users" || 
                pageType == "Contacts" || pageType == "Entities" || pageType == "Projects" || (pageType == "Brands" && userRole == 1) || 
                (pageType == "Websites" && userRole == 1)) ? 
                <img className='create' src={create} alt="create" onClick={navigateTo}></img> : <div style={{inlineSize: "30px"}}></div>}
                {(pageType == "Entities" || pageType == "Contacts") &&
                 <div className='import-section'>
                    <img className='import-btn' src={importIcon} alt="import" onClick={openImportPopup}></img>                       
                </div>
                }
                {showShare &&
                    <>
                        <div className='share-details' ref={sharewrapperRef}>
                            { link &&
                                <a href={`mailto:?body=${link}`} target="_blank">
                                    <div id='email-content' className='share-content email' style={{ border: `${emailupdate ? '1px solid #1896E1' : ''}`, background: `${emailupdate ? 'rgba(22, 140, 208, 0.14)' : ''}` }} onClick={Email}>
                                        <div className='share-image'>
                                            <img src={`${emailupdate ? emailColor : email}`} alt='email'></img>
                                        </div>
                                        <div className='share-text' style={{ color: `${emailupdate ? '#1896E1' : ''}` }}>Email</div>
                                    </div>
                                </a>
                            }
                            { !link &&  
                                <div id='email-content' className='share-content email' style={{ border: `${emailupdate ? '1px solid #1896E1' : ''}`, background: `${emailupdate ? 'rgba(22, 140, 208, 0.14)' : ''}` }} onClick={Email}>
                                    <div className='share-image'>
                                        <img src={`${emailupdate ? emailColor : email}`} alt='email'></img>
                                    </div>
                                    <div className='share-text' style={{ color: `${emailupdate ? '#1896E1' : ''}` }}>Email</div>
                                </div>
                            }
                            <div id='print-content' className='share-content print'onClick={() => Print('print', filename)} style={{ border: `${printupdate ? '1px solid #1896E1' : ''}`, background: `${printupdate ? 'rgba(22, 140, 208, 0.14)' : ''}` }}>
                                <div className='share-image'>
                                    <img src={`${printupdate ? printColor : print}`} alt='print'></img>
                                </div>
                                <div className='share-text' style={{ color: `${printupdate ? '#1896E1' : ''}` }}>Print</div>
                            </div>
                            {pageType === "Projects" &&                           
                                <div id='download-content' className='share-content download' onClick={handleShowDownload} style={{ border: `${downloadupdate ? '1px solid #1896E1' : ''}`, background: `${downloadupdate ? 'rgba(22, 140, 208, 0.14)' : ''}` }}>
                                    <div className='share-image'>
                                        <img src={`${downloadupdate ? downloadColor : download}`} alt='download'></img>
                                    </div>
                                    <div className='share-text share-text' style={{ color: `${downloadupdate ? '#1896E1' : ''}` }}>Download</div>
                                </div>}

                            {(pageType == "Contacts" || pageType == "Entities" || pageType == "Brands" || pageType == "ProjectsReports" 
                            || pageType == "Roles" || pageType == "Websites" || pageType == "Users") && 
                                <div className='download'>
                                    <CSVLink data={downloadarray} headers={headers} filename={fileName}>
                                        <div id='download-content' className='share-content' style={{ border: `${downloadupdate ? '1px solid #1896E1' : ''}`, background: `${downloadupdate ? 'rgba(22, 140, 208, 0.14)' : ''}` }} onClick={Download}>
                                            <div className='share-image'>
                                                <img src={`${downloadupdate ? downloadColor : download}`} alt='download'></img>
                                            </div>
                                            <div className='share-text share-text' style={{ color: `${downloadupdate ? '#1896E1' : ''}` }}>Download</div>
                                        </div>
                                    </CSVLink>
                                </div>
                            }
                        </div>
                        <div className='share-details-arrow'></div>
                    </>
                }
                {pageType == "Projects" && 
                <ListDownload showdownload={showdownload} handleHideDownload={handleHideDownload} setDownloadtype={setDownloadtype} downloadtype={downloadtype} 
                downloadarray={downloadarray} headers={headers} filename={fileName} downloadDate={downloadDate} setDownloadDate={setDownloadDate}/>}                       
            </div>
        </>
    )
}

export default SearchSection;